<template>
<div class="FansMemberMgt">
</div>
</template>

<script>
export default {
    name: 'FansMemberMgt',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.FansMemberMgt {
}
</style>
